import React from 'react';
import { Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import StyleRoundedIcon from '@mui/icons-material/StyleRounded';
import { formatInt } from '../../utils/format';
import WidgetShell from './WidgetShell';

function EconomyWidget({ stats }) {
  const items = [
    { label: 'Wins', value: formatInt(stats?.runs?.won) },
    { label: 'Targets Reached', value: formatInt(stats?.economy?.totalTargetsReached) },
    { label: 'Shop Visits', value: formatInt(stats?.economy?.totalShopVisits) },
    { label: 'Shop Selections', value: formatInt(stats?.economy?.totalShopSelections) },
    { label: 'Shop Skips', value: formatInt(stats?.economy?.totalShopSkips) },
    { label: 'Rounds Completed', value: formatInt(stats?.economy?.totalRoundsCompleted) },
  ];

  return (
    <WidgetShell
      icon={<StyleRoundedIcon color="primary" fontSize="small" />}
      title="Economy"
    >
      <Stack spacing={1}>
        {items.map((item) => (
          <Stack
            key={item.label}
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              px: 1.2,
              py: 0.9,
              borderRadius: 2,
              backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.04),
            }}
          >
            <Typography variant="body2" color="text.secondary">
              {item.label}
            </Typography>
            <Typography sx={{ fontWeight: 800 }}>{item.value}</Typography>
          </Stack>
        ))}
      </Stack>
    </WidgetShell>
  );
}

export default EconomyWidget;
